module.exports = __webpack_public_path__ + "img/public/SiteIcons/Show-up-arrow.svg?6cc6bab3";